// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-content {
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  background: #fff;
}
.dropdown-content .ant-dropdown-menu {
  box-shadow: none;
}
.dropdown-content .ant-dropdown-menu .ant-dropdown-menu-item {
  padding: 5px;
}
.dropdown-content .ant-dropdown-menu .ant-dropdown-menu-item > svg.icon {
  font-size: 14px;
  margin-inline: 2px;
}
.dropdown-content .ant-dropdown-menu .ant-dropdown-menu-title-content {
  flex: auto;
  margin: 0 5px;
}
.linkFile {
  clear: both;
  color: #106a90;
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  margin: 0px;
  padding: 2px 5px;
  transition: all 0.3s;
}
.linkFile a {
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
  width: 100%;
}
.linkFile:hover {
  background-color: #F5F5F5;
  border-radius: 3px;
}
.fileTitle {
  display: flex;
  clear: both;
  cursor: pointer;
  font-size: 12px;
  line-height: 12px;
  margin: 0;
  padding: 0;
  transition: all 0.3s;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  color: rgba(0, 0, 0, 0.45);
}
.fileName {
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
}
.colFile {
  font-size: 18px;
  color: #106a90;
  width: 21px;
  height: 21px;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
}
.colFile:hover {
  background: #106a90;
  border-radius: 3px;
  color: #ffffff;
}
.customFile {
  max-height: 350px;
  overflow: overlay;
}
.customFile .ant-dropdown-menu-title-content {
  flex: auto;
  max-width: 350px;
}
.customFile .ant-dropdown-menu-item,
.customFile .ant-dropdown-menu-submenu-title {
  padding: 2px 6px;
}
.customFile .ant-dropdown-menu {
  padding: 0;
}
.customFile .ant-dropdown-menu-title-content {
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/layers-tree/DropdownActions.less"],"names":[],"mappings":"AAAA;EACC,oHAAA;EAIA,gBAAA;AAFD;AAKA;EACC,gBAAA;AAHD;AAEA;EAIE,YAAA;AAHF;AADA;EAQE,eAAA;EACA,kBAAA;AAJF;AALA;EAaE,UAAA;EACA,aAAA;AALF;AASA;EACC,WAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AAPD;AADA;EAWE,qBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;AAPF;AAUC;EACC,yBAAA;EACA,kBAAA;AARF;AAaA;EACC,aAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;AAXD;AAcA;EACC,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AAZD;AAeA;EACC,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;AAbD;AAeC;EACC,mBAAA;EACA,kBAAA;EACA,cAAA;AAbF;AAiBA;EACC,iBAAA;EACA,iBAAA;AAfD;AAaA;EAKE,UAAA;EACA,gBAAA;AAfF;AASA;;EAWE,gBAAA;AAhBF;AAKA;EAeE,UAAA;AAjBF;AAEA;EAmBE,gBAAA;AAlBF","sourcesContent":[".dropdown-content {\n\tbox-shadow:\n\t\t0 3px 6px -4px rgb(0 0 0 / 12%),\n\t\t0 6px 16px 0 rgb(0 0 0 / 8%),\n\t\t0 9px 28px 8px rgb(0 0 0 / 5%);\n\tbackground: #fff;\n}\n\n.dropdown-content .ant-dropdown-menu {\n\tbox-shadow: none;\n\n\t.ant-dropdown-menu-item {\n\t\tpadding: 5px;\n\t}\n\n\t.ant-dropdown-menu-item>svg.icon {\n\t\tfont-size: 14px;\n\t\tmargin-inline: 2px;\n\t}\n\n\t.ant-dropdown-menu-title-content {\n\t\tflex: auto;\n\t\tmargin: 0 5px;\n\t}\n}\n\n.linkFile {\n\tclear: both;\n\tcolor: #106a90;\n\tcursor: pointer;\n\tfont-size: 14px;\n\tline-height: 22px;\n\tmargin: 0px;\n\tpadding: 2px 5px;\n\ttransition: all 0.3s;\n\n\ta {\n\t\ttext-decoration: none;\n\t\tcolor: inherit;\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\twidth: 100%;\n\t}\n\n\t&:hover {\n\t\tbackground-color: #F5F5F5;\n\t\tborder-radius: 3px;\n\t}\n}\n\n\n.fileTitle {\n\tdisplay: flex;\n\tclear: both;\n\tcursor: pointer;\n\tfont-size: 12px;\n\tline-height: 12px;\n\tmargin: 0;\n\tpadding: 0;\n\ttransition: all 0.3s;\n\talign-items: center;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\tcolor: rgba(0, 0, 0, .45);\n}\n\n.fileName {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tdisplay: block;\n\twhite-space: nowrap;\n}\n\n.colFile {\n\tfont-size: 18px;\n\tcolor: #106a90;\n\twidth: 21px;\n\theight: 21px;\n\tdisplay: flex;\n\tjustify-items: center;\n\tjustify-content: center;\n\talign-items: center;\n\n\t&:hover {\n\t\tbackground: #106a90;\n\t\tborder-radius: 3px;\n\t\tcolor: #ffffff;\n\t}\n}\n\n.customFile {\n\tmax-height: 350px;\n\toverflow: overlay;\n\n\t.ant-dropdown-menu-title-content {\n\t\tflex: auto;\n\t\tmax-width: 350px;\n\t}\n\n\t.ant-dropdown-menu-item,\n\t.ant-dropdown-menu-submenu-title {\n\t\tpadding: 2px 6px;\n\t}\n\n\t.ant-dropdown-menu {\n\t\tpadding: 0;\n\t}\n\n\t.ant-dropdown-menu-title-content {\n\t\toverflow: hidden;\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
